// @flow
import * as React from "react";

import styles from "./TableRow.scss";
import type { TableHeader } from "../Table";

export type TableRowProps = {
  product: string,
  amount: number,
  onClick: (id: number) => void,
  onKeyDown: (e: Event, id: number) => void,
  rowData: Array<React.Node>,
  tableHeaders: Array<TableHeader>
};

const TableRow = ({
  product,
  amount,
  onClick,
  onKeyDown,
  rowData,
  tableHeaders
}: TableRowProps) => {
  if (!rowData) {
    return null;
  }

  return (
    <tr
      tabIndex="0"
      role="button"
      aria-label={`${product}, ${amount}`}
      className={styles.row}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {tableHeaders.map(({ columnId }, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <td key={columnId + index}>{rowData[columnId]}</td>
      ))}
    </tr>
  );
};

export default TableRow;
